import { useQuery } from '@tanstack/react-query'
import { adminDiagnosticsApi, type QuizSetSummary } from '@/api/adminDiagnostics'
import { compareLevelSets, isPreschoolLevelSet } from '@/utils/levelSetName'

/** 진단 배정 모달용 퀴즈셋(age/grade). 진단 배정 목록은 P2에서 원생 목록 응답에 inline되므로 여기서 fetch하지 않는다. */
export function useDiagnosticSets({ enabled = true }: { enabled?: boolean } = {}) {
  const setsQ = useQuery({
    queryKey: ['quiz-sets-all'],
    queryFn: () => adminDiagnosticsApi.listQuizSets(),
    enabled,
  })
  const sets: QuizSetSummary[] = setsQ.data?.data.data ?? []
  return {
    ageSets: sets.filter((s) => s.levelType === 'age'),
    gradeSets: sets.filter((s) => s.levelType === 'grade' && !isPreschoolLevelSet(s)).sort(compareLevelSets),
    isLoading: !enabled || setsQ.isPending,
  }
}
